import { render, staticRenderFns } from "./GiftLayout.vue?vue&type=template&id=fdb1acea&scoped=true&"
import script from "./GiftLayout.vue?vue&type=script&lang=js&"
export * from "./GiftLayout.vue?vue&type=script&lang=js&"
import style0 from "./GiftLayout.vue?vue&type=style&index=0&id=fdb1acea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb1acea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdb1acea')) {
      api.createRecord('fdb1acea', component.options)
    } else {
      api.reload('fdb1acea', component.options)
    }
    module.hot.accept("./GiftLayout.vue?vue&type=template&id=fdb1acea&scoped=true&", function () {
      api.rerender('fdb1acea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/GiftLayout.vue"
export default component.exports